/* Calacas · mejoras de la tienda (29/10/2026)
   - Vistos recientemente (en el navegador del cliente, sin cuentas)
   - «Compra segura»: cómo se paga y se envía, con enlace a reseñas reales
   - Avance del pack 3 clásicos = S/100 (en el producto y en el carrito)
   - Filtro por tema: mantener filtros al cambiar de tema y desplegar Anime
   Todo se agrega por JS: no se tocan las secciones de producto. */
(function () {
  'use strict';
  if (window.__mejorasCalacas) return;
  window.__mejorasCalacas = true;

  var CLAVE_VISTOS = 'cc-vistos';
  var MAX_VISTOS = 12;
  var PACK = { cantidad: 3, precio: 100, url: '/pages/promos?view=arma-tu-pack' };
  var RESENAS = '/pages/resenas';
  var WA = 'https://wa.me/51970519995';

  var ruta = location.pathname.replace(/\/$/, '');
  var esProducto = /\/products\/[^/]+$/.test(ruta);
  var esColeccion = /\/collections\/[^/]+$/.test(ruta);
  var esCarrito = /\/cart$/.test(ruta);

  function leer(clave, def) { try { return JSON.parse(localStorage.getItem(clave)) || def; } catch (e) { return def; } }
  function guardar(clave, v) { try { localStorage.setItem(clave, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function soles(n) { n = +n; return 'S/' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); }
  function meta(prop) { var m = document.querySelector('meta[property="' + prop + '"]'); return m ? m.getAttribute('content') : ''; }

  /* ---------- vistos recientemente ---------- */
  function registrarVisto() {
    var handle = ruta.split('/products/')[1];
    if (!handle) return;
    var img = meta('og:image:secure_url') || meta('og:image');
    var item = { h: handle, t: (meta('og:title') || document.title).replace(/\s*[|–—].*$/, ''), p: meta('og:price:amount'), i: img ? img.replace(/^http:/, 'https:') : '', f: Date.now() };
    var lista = leer(CLAVE_VISTOS, []).filter(function (x) { return x && x.h !== handle; });
    lista.unshift(item);
    guardar(CLAVE_VISTOS, lista.slice(0, MAX_VISTOS));
  }
  function pintarVistos(antesDe, padre) {
    var actual = esProducto ? ruta.split('/products/')[1] : '';
    var lista = leer(CLAVE_VISTOS, []).filter(function (x) { return x && x.h && x.h !== actual; }).slice(0, 8);
    if (lista.length < 2) return; // con uno solo no vale la pena
    var tarjetas = lista.map(function (x) {
      var src = x.i ? x.i.split('?')[0] + '?width=360' : '';
      return '<a class="ccv__item" href="/products/' + esc(x.h) + '">' +
        (src ? '<img src="' + esc(src) + '" alt="' + esc(x.t) + '" loading="lazy" decoding="async" width="360" height="360">' : '<span class="ccv__vacio"></span>') +
        '<span class="ccv__nombre">' + esc(x.t) + '</span>' + (x.p ? '<span class="ccv__precio">' + esc(soles(String(x.p).replace(',', '.'))) + '</span>' : '') + '</a>';
    }).join('');
    var bloque = el('<section class="ccv page-width" aria-labelledby="ccv-titulo"><div class="ccv__cab"><h2 id="ccv-titulo">Vistos <mark>recientemente</mark></h2>' +
      '<button type="button" class="ccv__borrar" data-ccv-borrar>Borrar</button></div><div class="ccv__fila">' + tarjetas + '</div></section>');
    bloque.querySelector('[data-ccv-borrar]').addEventListener('click', function () { guardar(CLAVE_VISTOS, []); bloque.remove(); });
    if (antesDe && antesDe.parentNode) antesDe.parentNode.insertBefore(bloque, antesDe); else (padre || document.querySelector('main') || document.body).appendChild(bloque);
  }

  /* ---------- compra segura ---------- */
  function compraSegura() {
    var ancla = document.querySelector('.cpp__proof') || document.querySelector('form[action*="/cart/add"] .ipz-cta, form[action*="/cart/add"] [type=submit]');
    if (!ancla || document.querySelector('.ccs')) return;
    var bloque = el(
      '<div class="ccs" role="region" aria-label="Compra segura">' +
        '<p class="ccs__titulo">Así compras, <mark>sin riesgo</mark></p>' +
        '<ol class="ccs__pasos">' +
          '<li><b>Pides</b><span>Por la web o por WhatsApp. Te confirmamos todo por WhatsApp.</span></li>' +
          '<li><b>Adelanto</b><span>Pagas una parte con Yape o Plin y estampamos tu polo en 1 a 2 días.</span></li>' +
          '<li><b>Recoges</b><span>Shalom lo lleva a tu agencia en 2 a 4 días hábiles. Pagas el resto y te damos la clave de recojo.</span></li>' +
        '</ol>' +
        '<p class="ccs__duda">¿Y si me estafan? Mira lo que dicen <a href="' + RESENAS + '">nuestros clientes con su polo en mano</a>, o escríbenos al <a href="' + WA + '" target="_blank" rel="noopener">WhatsApp</a>.</p>' +
      '</div>');
    // debajo de todo lo de comprar (incluido el «Comprar ahora» del formulario contra entrega): no empuja los botones
    var form = ancla.closest('form'), trust = document.querySelector('.cpp__trust');
    if (trust) trust.parentNode.insertBefore(bloque, trust);
    else if (form) form.parentNode.insertBefore(bloque, form.nextSibling);
    else ancla.parentNode.insertBefore(bloque, ancla.nextSibling);
  }

  /* ---------- pack 3 clásicos ---------- */
  function contarClasicos(carrito) {
    return (carrito.items || []).reduce(function (n, it) {
      var txt = (it.variant_title || '') + ' ' + (it.options_with_values || []).map(function (o) { return o.value; }).join(' ');
      return n + (/cl[aá]sico/i.test(txt) ? it.quantity : 0);
    }, 0);
  }
  function textoPack(n) {
    if (n <= 0) return 'Llévate <b>3 polos clásicos por S/100</b>. <a href="' + PACK.url + '">Arma tu pack</a>';
    var resto = n % PACK.cantidad;
    if (resto === 0) return '¡Listo! Tienes <b>' + n + ' clásicos</b>: ya tienes tu pack de 3 × S/100 🔥';
    var faltan = PACK.cantidad - resto;
    return 'Llevas <b>' + n + ' clásico' + (n > 1 ? 's' : '') + '</b>. Te ' + (faltan > 1 ? 'faltan ' : 'falta ') + '<b>' + faltan + '</b> para el pack de 3 × S/100. <a href="' + PACK.url + '">Arma tu pack</a>';
  }
  function barraPack(dondeAntes, dondePadre) {
    var caja = el('<div class="ccp" aria-live="polite"><div class="ccp__barra"><span></span></div><p class="ccp__texto">…</p></div>');
    if (dondeAntes && dondeAntes.parentNode) dondeAntes.parentNode.insertBefore(caja, dondeAntes); else if (dondePadre) dondePadre.insertBefore(caja, dondePadre.firstChild); else return;
    function actualizar() {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var n = contarClasicos(c), resto = n % PACK.cantidad, lleno = n > 0 && resto === 0;
        caja.querySelector('.ccp__barra span').style.width = (lleno ? 100 : (resto / PACK.cantidad) * 100) + '%';
        caja.classList.toggle('is-lleno', lleno);
        caja.querySelector('.ccp__texto').innerHTML = textoPack(n);
      }).catch(function () { caja.remove(); });
    }
    actualizar();
    document.addEventListener('cart:refresh', function () { setTimeout(actualizar, 300); });
    document.addEventListener('cc:carrito', actualizar);
  }

  /* ---------- temas: mantener filtros y desplegar Anime ---------- */
  function temas() {
    var nav = document.querySelector('.cct');
    if (!nav) return;
    var params = new URLSearchParams(location.search), guardar = new URLSearchParams();
    params.forEach(function (v, k) { if (/^filter\.|^sort_by$/.test(k)) guardar.append(k, v); });
    var extra = guardar.toString();
    if (extra) nav.querySelectorAll('[data-cct]').forEach(function (a) { a.href = a.getAttribute('href') + '?' + extra; });
    var boton = nav.querySelector('[data-cct-anime]'), series = nav.querySelector('[data-cct-series]');
    if (boton && series) boton.addEventListener('click', function () {
      var abrir = series.hidden; series.hidden = !abrir; boton.setAttribute('aria-expanded', String(abrir)); boton.classList.toggle('is-on', abrir);
    });
    var activo = nav.querySelector('.cct__chip.is-on:not(.cct__chip--grupo)');
    if (activo) { var fila = activo.parentNode; fila.scrollLeft = activo.getBoundingClientRect().left - fila.getBoundingClientRect().left - 24; }
  }

  function iniciar() {
    try {
      if (esProducto) {
        registrarVisto();
        compraSegura();
        var proof = document.querySelector('.cpp__proof');
        var formAdd = document.querySelector('.ccs') || document.querySelector('form[action*="/cart/add"]');
        if (proof) barraPack(proof); else if (formAdd) barraPack(formAdd.nextSibling, formAdd.parentNode);
        var relacionados = document.querySelector('[id*="related-products"], product-recommendations');
        pintarVistos(relacionados && relacionados.closest('.shopify-section'));
      } else if (esColeccion) {
        temas();
        pintarVistos(null, (document.querySelector('#ProductGridContainer') || {}).parentNode);
      } else if (esCarrito) {
        var items = document.querySelector('cart-items, #main-cart-items, .cart__items');
        barraPack(items);
        pintarVistos(null, document.querySelector('main'));
      } else if (ruta === '') {
        var pie = document.querySelector('.shopify-section-group-footer-group, footer');
        pintarVistos(pie, document.querySelector('main'));
      }
    } catch (e) { if (window.console) console.warn('[mejoras-calacas]', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  window.CalacasMejoras = { contarClasicos: contarClasicos, textoPack: textoPack };
})();
